import Layout from '@/components/feature/Layout';
import HeroSection from './components/HeroSection';
import StatsSection from './components/StatsSection';
import NewsSection from './components/NewsSection';
import ProfileSection from './components/ProfileSection';
import WorksSection from './components/WorksSection';
import PhotosSection from './components/PhotosSection';
import EventsSection from './components/EventsSection';
import CommunitySection from './components/CommunitySection';
import CTASection from './components/CTASection';

export default function Home() {
  return (
    <Layout>
      <HeroSection />
      <StatsSection />
      <NewsSection />
      <ProfileSection />
      <WorksSection />
      <PhotosSection />
      <EventsSection />
      <CommunitySection />
      <CTASection />
    </Layout>
  );
}